<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId"/>
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">微信昵称</a-select-option>
                  <a-select-option value="2">微信ID</a-select-option>
                  <a-select-option value="3">用户UID</a-select-option>
                  <a-select-option value="4">机器人ID</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="日志类型">
                <a-select v-model="queryParam.type" placeholder="请选择" allowClear>
                  <a-select-option
                    v-for="option in type"
                    :key="option.id"
                    :value="option.id"
                  >{{option.title}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="操作类型">
                    <a-select v-model="queryParam.search_type" placeholder="请选择" allowClear>
                        <a-select-option value="1">发钱</a-select-option>
                        <a-select-option value="2">扣钱</a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator"></div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text">{{text}}</span>
        <span slot="type" slot-scope="text">
          <a-tag color="blue">{{text | getTypeTitle(type)}}</a-tag>
        </span>
        <span slot="balance" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span>
         <span slot="integral" slot-scope="text">
           <span>{{ text / 100 || 0 }}</span>
         </span>
        <span slot="remark" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="createdt" slot-scope="text, record">
          <span>{{ record.createdt }}</span>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import CapitalApi from '@/api/capital'
import { PageView } from '@/layouts'
import { ExceptionPage } from '@/components'
import { CAPITAL_TYPE } from './data'
export default {
  name: 'CapitalLog',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id'
        },
        {
          title: '用户UID',
          dataIndex: 'userid'
        },
        {
          title: '微信昵称',
          dataIndex: 'get_user_info.nickname'
        },
        {
          title: '微信ID',
          dataIndex: 'wxid'
        },
        {
          title: '积分',
          dataIndex: 'integral',
          scopedSlots: { customRender: 'integral' }
        },
        {
          title: '操作金额',
          dataIndex: 'balance',
          scopedSlots: { customRender: 'balance' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 200,
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '创建时间',
          scopedSlots: { customRender: 'createdt' },
          width: 180,
          sorter: true
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CapitalApi.getCapitalLog(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      },
      // 类型
      type: CAPITAL_TYPE
    }
  },
  filters: {
    getTypeTitle(type, types) {
      const arr = types.filter(val => {
        return val.id == type
      })
      return arr[0]['title']
    }
  },
  created() {},
  activated(){
    // 处理跳转财产日志
    if(this.$route.params.uid){
      this.$nextTick(()=>{
        this.$set(this.queryParam,'search_condition','3')
        this.$set(this.queryParam,'keywords',this.$route.params.uid)
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
